import { render, staticRenderFns } from "./UserFollowCard.vue?vue&type=template&id=0a947838&scoped=true&"
import script from "./UserFollowCard.vue?vue&type=script&lang=js&"
export * from "./UserFollowCard.vue?vue&type=script&lang=js&"
import style0 from "./UserFollowCard.vue?vue&type=style&index=0&id=0a947838&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a947838",
  null
  
)

export default component.exports